import { HStack, Text } from '@chakra-ui/react'

import { ChartBarLegendSwatch } from './ChartMarker'
import {
  CHART_BAR_LEGEND_FONT_SIZE,
  CHART_BAR_LEGEND_FONT_WEIGHT,
  CHART_BAR_LEGEND_GAP,
  CHART_BAR_LEGEND_LINE_HEIGHT,
} from './chart.constants'
import { useChartColors } from './useChartColors'

export interface ChartBarLegendItemProps {
  color: string
  label: string
}

/** Figma: horizontal teal swatch + “Average Dwell” label (header + in-chart `CustomLegend`). */
export const ChartBarLegendItem = ({
  color,
  label,
}: ChartBarLegendItemProps) => {
  const chartColors = useChartColors()

  return (
    <HStack alignItems="center" spacing={CHART_BAR_LEGEND_GAP}>
      <ChartBarLegendSwatch color={color} />
      <Text
        as="span"
        color={chartColors.legendLabelColor}
        fontSize={CHART_BAR_LEGEND_FONT_SIZE}
        fontWeight={CHART_BAR_LEGEND_FONT_WEIGHT}
        lineHeight={CHART_BAR_LEGEND_LINE_HEIGHT}
      >
        {label}
      </Text>
    </HStack>
  )
}
